/*
 *
 * TreatmentFlow actions
 *
 */

import {
  GET_PRODUCT_TYPES,
  GET_PRODUCT_TYPES_SUCCESS,
  GET_PRODUCT_TYPES_ERROR,
  GET_CONFIGURATION,
  GET_ACTIVE_PRODUCT_PLAN,
  GET_ACTIVE_PRODUCT_PLAN_SUCCESS,
  GET_ACTIVE_PRODUCT_PLAN_ERROR,
  CREATE_ACTION_PLAN,
  CREATE_ACTION_PLAN_SUCCESS,
  CREATE_ACTION_PLAN_ERROR,
  GET_PRODUCT_CONFIGURATION,
  GET_PRODUCT_CONFIGURATION_SUCCESS,
  GET_PRODUCT_CONFIGURATION_ERROR,
  RESET,
} from "./constants";

export function getProductTypes() {
  return {
    type: GET_PRODUCT_TYPES,
  };
}

export function getProductTypesSuccess(data) {
  return {
    type: GET_PRODUCT_TYPES_SUCCESS,
    data,
  };
}

export function getProductTypesError(error) {
  return {
    type: GET_PRODUCT_TYPES_ERROR,
    error,
  };
}

export function getConfiguration(lowerId, upperId) {
  return {
    type: GET_CONFIGURATION,
    lowerId,
    upperId,
  };
}

export function getActiveProductPlan(patientId) {
  return {
    type: GET_ACTIVE_PRODUCT_PLAN,
    patientId,
  };
}

export function getActiveProductPlanSuccess(data) {
  return {
    type: GET_ACTIVE_PRODUCT_PLAN_SUCCESS,
    data,
  };
}

export function getActiveProductPlanError(error) {
  return {
    type: GET_ACTIVE_PRODUCT_PLAN_ERROR,
    error,
  };
}

export function createActionPlan(patientId, configId) {
  return {
    type: CREATE_ACTION_PLAN,
    patientId,
    configId,
  };
}

export function createActionPlanSuccess(data) {
  return {
    type: CREATE_ACTION_PLAN_SUCCESS,
    data,
  };
}

export function createActionPlanError(error) {
  return {
    type: CREATE_ACTION_PLAN_ERROR,
    error,
  };
}

export function getProductConfiguration(upperId, lowerId) {
  return {
    type: GET_PRODUCT_CONFIGURATION,
    upperId,
    lowerId,
  };
}

export function getProductConfigurationSuccess(data) {
  return {
    type: GET_PRODUCT_CONFIGURATION_SUCCESS,
    data,
  };
}

export function getProductConfigurationError(error) {
  return {
    type: GET_PRODUCT_CONFIGURATION_ERROR,
    error,
  };
}

export function reset() {
  return {
    type: RESET,
  };
}
